import { animate, AnimationTriggerMetadata, AUTO_STYLE, state, style, transition, trigger } from '@angular/animations';

import { IAnimationOptions } from '../_interfaces/animate.interface';

export interface ISlideInOutHorizontallyAnimationsOptions
  extends IAnimationOptions {
  translate: string;
}

const DEFAULT_DURATION = 500;

export function slideInOutHorizontallyAnimation(options?: ISlideInOutHorizontallyAnimationsOptions): AnimationTriggerMetadata {
  return trigger((options && options.anchor) || 'slideInOutHorizontally', [
    state(
      '0',
      style({
        height: 0,
        transform: 'translate3d(-' + options.translate + ', 0, 0)'
      })
    ),
    state(
      '0-with-height',
      style({
        height: '100%',
        transform: 'translate3d(-' + options.translate + ', 0, 0)'
      })
    ),
    state(
      '1',
      style({
        height: AUTO_STYLE,
        transform: 'translate3d(0, 0, 0)'
      })
    ),
    transition('0 => 1', [animate('{{durationIn}}ms {{delayIn}}ms')], {
      params: {
        delayIn: (options && options.delayIn) || 0,
        durationIn: (options && options.durationIn) || DEFAULT_DURATION,
        translate: (options && options.translate) || '100%'
      }
    }),
    transition('1 => 0', [animate('{{durationOut}}ms {{delayOut}}ms')], {
      params: {
        delayOut: (options && options.delayOut) || 0,
        durationOut: (options && options.durationOut) || DEFAULT_DURATION,
        translate: (options && options.translate) || '100%'
      }
    }),
    transition(
      '0-with-height => 1',
      [animate('{{durationIn}}ms {{delayIn}}ms')],
      {
        params: {
          delayIn: (options && options.delayIn) || 0,
          durationIn: (options && options.durationIn) || DEFAULT_DURATION,
          translate: (options && options.translate) || '100%'
        }
      }
    ),
    transition(
      '1 => 0-with-height',
      [animate('{{durationOut}}ms {{delayOut}}ms')],
      {
        params: {
          delayOut: (options && options.delayOut) || 0,
          durationOut: (options && options.durationOut) || DEFAULT_DURATION,
          translate: (options && options.translate) || '100%'
        }
      }
    )
  ]);
}
